// Giờ 24h thuần JS — KHÔNG phụ thuộc ngôn ngữ/khu vực của trình duyệt.
//
// Vì sao có file này: <input type="time"> và <input type="datetime-local"> hiển thị theo cài đặt
// vùng của HỆ ĐIỀU HÀNH (máy để English/US thì ra "02:30 PM"), không có thuộc tính nào ép 24h.
// Hệ thống cần giờ 24h ở mọi nơi nên các ô nhập giờ dùng TimeInput24/DateTimeInput24 (xem
// components/ui/TimeInput24.js) dựng trên các hàm ở đây.

const pad2 = (n) => String(n).padStart(2, '0');

/**
 * Đọc giờ nhập tay kiểu lỏng → 'HH:mm' hoặc null nếu không hợp lệ.
 * Chấp nhận: "08:30", "8:30", "830", "0830", "8", "8h30", "08.30", "08:30:15" (bỏ giây).
 */
export function normalizeTime(input) {
  if (input === null || input === undefined) return null;
  const t = String(input).trim().toLowerCase();
  if (!t) return null;
  let h;
  let m;
  const sep = t.match(/^(\d{1,2})\s*[:h.]\s*(\d{1,2})?(?:\s*[:.]\s*\d{1,2})?$/);
  if (sep) {
    h = parseInt(sep[1], 10);
    m = sep[2] === undefined ? 0 : parseInt(sep[2], 10);
  } else if (/^\d{1,4}$/.test(t)) {
    if (t.length <= 2) { h = parseInt(t, 10); m = 0; }
    else { h = parseInt(t.slice(0, t.length - 2), 10); m = parseInt(t.slice(-2), 10); }
  } else {
    return null;
  }
  if (!Number.isInteger(h) || !Number.isInteger(m) || h < 0 || h > 23 || m < 0 || m > 59) return null;
  return `${pad2(h)}:${pad2(m)}`;
}

/**
 * Định dạng khi người dùng đang GÕ: chỉ giữ số và dấu ':', tự chèn ':' sau 2 số đầu
 * ("083" → "08:3", "0830" → "08:30"), tối đa 5 ký tự.
 */
export function formatTyping(raw) {
  const s = String(raw || '').replace(/[^\d:]/g, '');
  if (s.includes(':')) {
    const [h, ...rest] = s.split(':');
    return `${h.slice(0, 2)}:${rest.join('').slice(0, 2)}`;
  }
  const d = s.slice(0, 4);
  return d.length > 2 ? `${d.slice(0, 2)}:${d.slice(2)}` : d;
}

/** 'YYYY-MM-DDTHH:mm[:ss]' (hoặc có dấu cách) → { date: 'YYYY-MM-DD', time: 'HH:mm' }; rỗng nếu không đọc được. */
export function splitDateTime(value) {
  if (!value || typeof value !== 'string') return { date: '', time: '' };
  const m = value.trim().match(/^(\d{4}-\d{2}-\d{2})(?:[T ](\d{1,2}:\d{2}))?/);
  if (!m) return { date: '', time: '' };
  return { date: m[1], time: m[2] ? normalizeTime(m[2]) || '' : '' };
}

/** Ghép ngày + giờ → 'YYYY-MM-DDTHH:mm'. Thiếu giờ → '' (chưa đủ thông tin để có một mốc thời gian). */
export function joinDateTime(date, time) {
  const t = normalizeTime(time);
  if (!date || !t) return '';
  return `${date}T${t}`;
}

/** Cộng/trừ ngày cho chuỗi 'YYYY-MM-DD' (tính theo UTC nên không lệch vì múi giờ/giờ mùa hè). Sai định dạng → ''. */
export function addDays(dateStr, n) {
  const m = typeof dateStr === 'string' && dateStr.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return '';
  const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3] + n));
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}
